export default __webpack_public_path__ + "static/media/2614486.51c7e057.jpg";